import HTTP from "@/_helpers/http";
import { SHORTDURATIONTRADES__API } from "@/_helpers/urls";
import { SHORTDURATIONTRADES__MUTATIONS } from "../mutation-types";
import { SHORTDURATIONTRADES__ACTIONS } from "../action-types";

const state = {
  trades: [],
  //   dashboardTradesData: {
  //     total: 0,
  //     totalProfit: 0,
  //     totalVolume: 0
  //   },
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
  },
  summaries: {
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0,
  },
  isLoading: false,
};

const getters = {};

const mutations = {
  // [SHORTDURATIONTRADES__MUTATIONS.DASHBOARDSHORTDURATIONTRADES](state, data) {
  //   state.dashboardSHORTDURATIONTRADESData = data?.data
  // },
  [SHORTDURATIONTRADES__MUTATIONS.SHORTDURATIONTRADES](state, data) {
    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1,
    };

    // Update summaries
    state.summaries = data?.data?.summaries || {
      totalProfit: 0,
      totalVolume: 0,
      totalEquity: 0,
    };

    state.lastUpdate = new Date().toISOString();
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  //   async [SHORTDURATIONTRADES__ACTIONS.DASHBOARDSHORTDURATIONTRADES]({ commit, state }) {
  //     try {
  //       const response = await HTTP().get(SHORTDURATIONTRADES__API.DASHBOARDSHORTDURATIONTRADES);

  //       commit(SHORTDURATIONTRADES__MUTATIONS.DASHBOARDSHORTDURATIONTRADES, response.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   },
  async [SHORTDURATIONTRADES__ACTIONS.SHORTDURATIONTRADES]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        page = 1,
        limit = 10,
        trading_account_type_id,
        search = "",
        duration,
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search }),
      }).toString();

      const response = await HTTP().get(
        `${SHORTDURATIONTRADES__API.SHORTDURATIONTRADES}${queryParams ? `?${queryParams}` : ""}`
      );

      if (response.status === 200) {
        commit(SHORTDURATIONTRADES__MUTATIONS.SHORTDURATIONTRADES, response.data);
      }
    } catch (error) {
      console.error("Error fetching:", error);
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
